const CHORDS = [
  "C",
  "Em",
  "G",
  "Bm",
  "D",
  "F#m",
  "A",
  "C#m",
  "E",
  "G#m",
  "B",
  "D#m",
  "F#",
  "B♭m",
  "D♭",
  "Fm",
  "A♭",
  "Cm",
  "E♭",
  "Gm",
  "B♭",
  "Dm",
  "F",
  "Am",
];



export default CHORDS;
